export default "__VITE_ASSET__BdTMnrM0__"